import React from 'react';
import { getRequest, postRequest } from '../../lib/apiUtils';

export default class IdleTimer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            active: false,
            expiresOn: ''
        };

        this.handleOnActive = this.handleOnActive.bind(this);
        this.handleStorageEvent = this.handleStorageEvent.bind(this);
    }

    events = ['mousemove', 'keydown', 'wheel', 'DOMMouseScroll', 'mouseWheel', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove'];
    defaultExpirationMS = 5400000; //90 MIN
    preExpirationTimeoutMS = 120000; //2 MIN - TO REQ REFRESH 2 MIN BEFORE TOKEN EXPIRATION
    timer = null;

    componentWillMount() {
        window.addEventListener('storage', this.handleStorageEvent, false);
        this.events.forEach(e => document.addEventListener(e, this.handleOnActive));
    }

    componentDidMount() {
        this.syncTimer(JSON.parse(localStorage.getItem('IdleTimer')));
    }

    componentWillUnmount() {
        clearTimeout(this.timer);

        window.removeEventListener('storage', this.handleStorageEvent, false);
        this.events.forEach(e => document.removeEventListener(e, this.handleOnActive));
    }

    handleStorageEvent(e) {
        if (e.key && e.key === 'IdleTimer') {
            if (e.oldValue === e.newValue) {
                return;
            }

            if (!e.newValue) { //when any browser tab logs out
                this.props.logout(true, true); //true for navigation only
            } else {
                this.syncTimer(JSON.parse(e.newValue));
            }
        }
    }

    syncTimer(idleTimer) {
        const timerExpiration = idleTimer ? new Date(idleTimer.expiresOn) - this.preExpirationTimeoutMS : null;
        if (idleTimer && timerExpiration > Date.now()) { //timer has not yet expired
            //sync timer and timer state
            if (idleTimer.expiresOn !== this.state.expiresOn) {
                clearTimeout(this.timer);

                const remainingTime = (timerExpiration - Date.now()) + 30000; //ADDING 30 SECONDS TO TIMEOUT WHEN SYNC TO ANOTHER TAB TO AVOID HAVING REQUEST MADE BY BOTH TABS ON IDENTICAL TIMEOUT
                this.timer = setTimeout(this.onTimeout.bind(this), remainingTime);
            }

            this.setState({ ...idleTimer });
        } else {
            this.reset();
        }
    }

    async reset() {
        clearTimeout(this.timer);
        this.setState({
            active: false,
            expiresOn: ''
        });

        const refresh = await this.getRefreshToken();
        if (refresh.success) {
            const timeout = refresh.expiresIn - this.preExpirationTimeoutMS;
            this.timer = setTimeout(this.onTimeout.bind(this), timeout);
            this.setLocalStorageIdleTimer({
                active: false,
                expiresOn: refresh.expiresOn
            });
        }
    }

    setLocalStorageIdleTimer(idleTimer) { //Window 'storage' event is not invoked on the browser tab that the local storage event is raised by, t/f setting state here
        localStorage.setItem('IdleTimer', JSON.stringify(idleTimer));
        this.setState({ ...idleTimer });
    }

    handleOnActive() {
        if (!this.state.active) {
            const idleTimer = JSON.parse(localStorage.getItem('IdleTimer'));
            if (idleTimer) {
                this.setLocalStorageIdleTimer({
                    ...idleTimer,
                    active: true
                });
            }
        }
    }

    async onTimeout() {
        if (this.state.active || this.props.alwaysRefresh) {
            this.reset();
        } else {
            this.props.logout(true); //IdleTimer removed from localStorage in LOGOUT ACTION
        }
    }

    async getRefreshToken() {
        let res = { success: true, timeout: this.defaultExpirationMS };

        const verification = await getRequest("/xsrfToken");

        if (verification.success) {
            const refresh = await postRequest(this.props.refreshUrl || "/account/refreshToken", null, { [verification.data.tokenName]: verification.data.token });

            if (refresh.success) {
                res.expiresIn = refresh.data.expiresIn ? refresh.data.expiresIn * 1000 : this.defaultExpirationMS; //converting S to MS (OR default)
                res.expiresOn = new Date(refresh.data.expiresOn).toLocaleString();
                const lastVerification = await getRequest("/xsrfToken");

                if (lastVerification.success) {
                    localStorage.setItem("RequestVerificationToken", lastVerification.data.token);
                }
            } else {
                res.success = false;
                this.props.logout(true);
            }
        } else {
            res.success = false;
            this.props.logout(true);
        }

        return res;
    }

    render() {
        return this.props.children;
    }
}


// WEBPACK FOOTER //
// ./src/components/layoutComponents/IdleTimer.jsx